import { render } from "./MediaFile.vue?vue&type=template&id=30882720&ts=true"
import script from "./MediaFile.vue?vue&type=script&lang=ts"
export * from "./MediaFile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__